module.exports = __webpack_public_path__ + "img/banners.64ef724c.png";